import PatientOverviewPAProgressStatus from 'dashboard/templates/views/Patient/PA/PatientOverviewPAProgressStatus';

export default {
  path: 'status',
  name: 'PatientRecordPAProgressStatus',
  component: PatientOverviewPAProgressStatus,
  meta: {
    // title: 'Patient Record - Physical Activity - Progress - Status',
    // title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')} - ${t('journeyBehaviourChangeGoals.status')}`,
    // title: 'Physical Activity - Status',
    title: t => `${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
